import React from "react";
import img2 from "../Images/pencil.png";
import img3 from "../Images/Vector.png";
import pdf from "../Images/pdf.png";

const TcDataComponent = ({
	handleDelete = () => {},
	handleEdit = () => {},
	data = [],
}) => {
	if (!data.length) {
		return null;
	}

	return (
		<div>
			<div className="table-responsive">
				<form>
					<table>
						<thead
							className="rounded-top"
							style={{ backgroundColor: "#cce6ff" }}
						>
							<tr>
								<th
									style={{
										borderTopLeftRadius: "16px",
										width: "10%",
									}}
								>
									Sr. No
								</th>
								<th
									style={{
										width: "10%",
									}}
								>
									Name
								</th>
								<th
									style={{
										width: "20%",
									}}
								>
									Admission Number
								</th>
								<th
									style={{
										width: "20%",
									}}
								>
									Date Of Birth
								</th>
								<th
									style={{
										width: "25%",
									}}
								>
									PDF
								</th>
								<th
									style={{
										borderTopRightRadius: "16px",
									}}
								/>
							</tr>
						</thead>
						<tbody>
							{data.map((fee, index) => {
								return (
									<tr
										key={fee.id}
										style={{
											borderBottom: "1px solid #A4A4A4",
											marginTop: "20px",
											height: "80px",
										}}
									>
										<td>{index + 1}</td>
										<td>{fee.name}</td>
										<td>{fee.admissionNumber}</td>
										<td>{fee.dob}</td>
										<td>
											{fee.pdf.name}
											<img src={pdf} alt="" />
										</td>
										<td>
											<button
												style={{
													background: "transparent",
													border: "none",
												}}
												onClick={(e) => {
													e.preventDefault();
													handleEdit(fee);
												}}
											>
												<img src={img2} alt="" />
											</button>
											<button
												style={{
													background: "transparent",
													border: "none",
												}}
												onClick={(e) => {
													e.preventDefault();
													handleDelete(fee);
												}}
											>
												<img src={img3} alt="" />
											</button>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</form>
			</div>
		</div>
	);
};

export default TcDataComponent;
